
import clienteAxios from "../config/axios";

export const getAllProcedimiento = async () => {
    return clienteAxios.get('/procedimiento');
};
export const addProcedimiento = async (procedimiento) => {
    return await clienteAxios.post('/procedimiento',{procedimiento});
}
export const updateProcedimiento = async (procedimiento) => {
    return await clienteAxios.put(`procedimiento/${procedimiento._id}`,{updates:procedimiento});
}
export const deleteProcedimiento = async (procedimiento) => {
    return await clienteAxios.delete(`procedimiento/${procedimiento._id}`);
}
export const getProcByID = async(procID) =>{
    return clienteAxios.get(`/procedimiento/${procID}`);
}